import React, { Component } from 'react';
// react component for creating dynamic tables
import ReactTable from 'react-table';
import {
  Grid,
  Row,
  Col,
  Navbar,
  FormGroup,
  FormControl,
  InputGroup,
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as FranchisesActions from './redux/FranchisesActions';

class FranchisesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentWillMount() {
    this.props.find({});
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  render() {
    let _this = this;
    let { history, Franchises } = this.props;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Franquicias'}{' '}
                    <div className="pull-right header-table">
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() =>
                          history.push('/admin/config/franchises/create')
                        }
                      >
                        Agregar Franquicia
                      </Button>
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={Franchises.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    data={Franchises.searchData || []}
                    page={Franchises.table.page}
                    sorted={Franchises.table.sorted}
                    filtered={Franchises.table.filtered}
                    pageSize={Franchises.table.pageSize}
                    onSortedChange={(change) =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={(change) =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={(change) =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={(change) =>
                      _this.props.changeTable('pageSize', change)
                    }
                    previousText={'Anterior'}
                    nextText={'Siguiente'}
                    loadingText={'Cargando...'}
                    noDataText={'No se encontraron registros'}
                    pageText={'Página'}
                    ofText={'de'}
                    rowsText={'filas'}
                    columns={[
                      {
                        Header: 'Nombre',
                        accessor: 'name',
                        minWidth: 110,
                      },
                      {
                        Header: 'Propietario',
                        accessor: 'owner',
                      },
                      {
                        Header: 'Teléfono',
                        accessor: 'phone',
                      },
                      {
                        Header: 'Email',
                        accessor: 'email',
                      },
                      {
                        Header: 'Estado',
                        accessor: 'address.stateId',
                      },
                      {
                        Header: 'Ciudad',
                        accessor: 'address.cityId',
                      },
                      {
                        Header: 'Mostrar solo Facturables',
                        accessor: 'hideOrders',
                        minWidth: 95,
                        Cell: (props) =>
                          props.original.hideOrders ? (
                            <span style={{ color: 'green' }}>Si</span>
                          ) : (
                            <span style={{ color: 'gray' }}>No</span>
                          ),
                      },
                      {
                        Header: 'Clave Privada',
                        accessor: 'privateId',
                        minWidth: 60,
                      },
                      {
                        Header: 'Acciones',
                        accessor: 'actions',
                        sortable: false,
                        filterable: false,
                        Cell: (props) => (
                          // we've added some custom button actions
                          <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <Button
                              onClick={() =>
                                history.push(
                                  '/admin/config/franchises/' +
                                  props.original.id
                                )
                              }
                              bsStyle="warning"
                              simple
                            >
                              Editar
                            </Button>{' '}
                          </div>
                        ),
                      },
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Franchises: state.Franchises,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(FranchisesActions, dispatch);
};

const FranchisesConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(FranchisesIndex);

export default FranchisesConnect;



// WEBPACK FOOTER //
// ./src/views/Franchises/FranchisesIndex.jsx